// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CspsPage_pageContainer__2WbbK","secondaryPageContainer":"CspsPage_secondaryPageContainer__1snd_"};